export default {
  title: "Myeuroservice",
  version: "1.3.0"
};
